import React from "react";
import { Button, Box } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const DraftSolutionActions = ({
    onBack,
    styles,
}) => {
    return (
        <Box className={styles.headerTop}>
            <Button
                startIcon={<ArrowBackIcon />}
                onClick={onBack}
                className={styles.backButton}
            >
                Back to Solutions
            </Button>
        </Box>
    );
};

export default DraftSolutionActions;